import { useMemo } from 'react';
// eslint-disable-next-line import/no-unresolved
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actionCreators } from '../store';

const useActions = () => {
  const dispatch = useDispatch();

  // combines action creators with the dispatch function
  return useMemo(() => bindActionCreators(actionCreators, dispatch), [dispatch]);
};

export default useActions;
